
import axios from 'axios'


const authApi = axios.create({
    baseURL: 'https://api360.360margaritaca.com.ve',
    // baseURL: 'https://api360.360margaritaca.com.ve',
    params: {
        key: 'AIzaSyBhCquFEBH1rgR5IJFo1v1qGiZzHDe2PVI'
    }
})

// console.log( process.env.NODE_ENV ) // TEST durante testing, 

export default authApi


